'use strict';
angular.module('schoolLinqApp').directive('popupDatePicker', [
	'$timeout',
	function ($timeout) {
		return {
			scope: {
				ngModel: '=',
				inputName: '@',
				openFlag: '=',
				blurFunction: '&',
				clickFunction: '&',
				ngModelOptions: '=',
				changeFunction: '&',
				isRequired: '=',
				isDisabled: '=',
				onlyWeekdays: '=',
				minDate: '=',
				maxDate: '=',
			},
			replace: true,
			restrict: 'E',
			require: '?^form',
			compile: function (element, attrs) {
				while (element[0].attributes.length > 0) {
					element[0].removeAttribute(element[0].attributes[0].name);
				}
				// Add back a class attribute to format the overall div.
				$(element).addClass('searchImageTextBoxContainer');

				if (typeof attrs.disabled !== 'undefined') {
					element.find('input').attr('disabled', 'disabled');
					element.find('button').attr('disabled', 'disabled');
				}

				if (typeof attrs.required !== 'undefined') {
					element.find('input').attr('required', 'required');
				}

				if (attrs.ngModelOptions) {
					element.find('input').attr('ng-model-options', attrs.ngModelOptions);
				}

				return function (scope, element, attrs, formCtrl) {
					scope.fixDate = function () {
						let dateFormats = ['MM/DD/YYYY', 'MM/DD/YY', 'M/D/YY', 'M/D/YYYY', 'M/DD/YY', 'M/DD/YYYY', 'MM/D/YY', 'MM/D/YYYY'];
						let input = element.find('input');
						let convertedDate = moment(input.val(), dateFormats, true);
						if (convertedDate.isValid()) {
							input.val(convertedDate.format('MM/DD/YYYY'));
							scope.ngModel = convertedDate.toDate();
						} else {
							input.val('');
							scope.ngModel = null;
						}
					};

					scope.clickfun = function () {
						if (attrs.clickFunction) {
							scope.clickFunction();
						}
					};

					scope.changefun = function (newDate) {
						$timeout(function () {
							if (attrs.changeFunction) {
								scope.changeFunction();
							}
						});
					};

					scope.disabled = function (data) {
						return scope.onlyWeekdays && data.mode === 'day' && (data.date.getDay() === 0 || data.date.getDay() === 6);
					};

					scope.dateOptions = {
						dateDisabled: scope.disabled,
						minDate: scope.minDate,
					};

					var ctrl = formCtrl && formCtrl[scope.inputName];

					var validateMin = function (modelValue) {
						if (scope.minDate) {
							ctrl && ctrl.$setValidity('lessThanMin', moment(modelValue).isSameOrAfter(moment(scope.minDate), 'date'));
						}
						return modelValue;
					};

					var validateMax = function (modelValue) {
						if (scope.maxDate) {
							ctrl && ctrl.$setValidity('moreThanMax', moment(modelValue).isSameOrBefore(moment(scope.maxDate), 'date'));
						}
						return modelValue;
					};

					scope.$watch('minDate', function (val) {
						scope.dateOptions.minDate = val;
						ctrl && validateMin(ctrl.$viewValue);
					});

					scope.$watch('maxDate', function (val) {
						scope.dateOptions.maxDate = val;
						ctrl && validateMax(ctrl.$viewValue);
					});

					if (ctrl) {
						ctrl.$parsers.unshift(validateMin);
						ctrl.$formatters.push(validateMin);
						ctrl.$parsers.unshift(validateMax);
						ctrl.$formatters.push(validateMax);
					}

					scope.blurfun = function () {
						scope.fixDate();

						$timeout(function () {
							if (attrs.blurFunction) {
								scope.blurFunction();
							}
						});
					};

					// Add slashes automatically for the user after 2 characters and four characters.
					element.find('input').on('keyup', function (e) {
						var v = this.value;
						let selectionStart = this.selectionStart;
						let selectionEnd = this.selectionEnd;
						let skipSlash = 0;

						// If the user has typed one digit followed by a forward-slash, fill in a zero.
						if (v.match(/^\d{1}\/$/) !== null) {
							this.value = '0' + this.value;
							skipSlash = 1;
						} else if (v.match(/^\d{2}$/) !== null && e.which !== 8) {
							this.value = v + '/';
							skipSlash = 1;
						}
						// If the user has typed one digit for the day and a forward slash, fill in a zero.
						else if (v.match(/^\d{2}\/\d{1}\/$/) !== null) {
							this.value = this.value.replace(/^(\d{2})\/(\d{1})\/$/, '$1/0$2/');
							skipSlash = 1;
						} else if (v.match(/^\d{2}\/\d{2}$/) !== null && e.which !== 8) {
							this.value = v + '/';
							skipSlash = 1;
						} else if (v.match(/^\d{3}$/) !== null) {
							this.value = this.value.replace(/^(\d{2})(\d{1})/, '$1/$2');
						}

						// Only forward slashes and numbers allowed in a date field.
						this.value = this.value.replace(/[^\/0123456789]/g, '');
						// if the user is just removes the day values (ex. 07//2017)
						// then leave it alone; otherwise replace any // with a single /
						if (v.match(/^\d{2}\/\/\d{4}$/) === null) {
							this.value = this.value.replace('//', '/');
						}
						this.selectionStart = selectionStart + skipSlash;
						this.selectionEnd = selectionEnd + skipSlash;
					});
					// enable adding or subtracting one day using '+' and '-' keys
					element.find('input').on('keydown', function (e) {
						var dateFormat = 'MM/DD/YYYY';
						if (this.value.length === 10 && moment(this.value, dateFormat).isValid()) {
							var keyPressed = e.originalEvent.keyCode;
							var daysToAdd = 0;
							var addDayKeys = [187, 61, 107]; // ['='(IE, Chrome), '='(Firefox), '+']
							var subtractDayKeys = [109, 189, 173]; // ['-', '_'(IE, Chrome), '_'(Firefox)]
							if (addDayKeys.indexOf(keyPressed) !== -1) {
								daysToAdd = 1;
							} else if (subtractDayKeys.indexOf(keyPressed) !== -1) {
								daysToAdd = -1;
							}
							if (daysToAdd !== 0) {
								this.value = moment(this.value, dateFormat).add(daysToAdd, 'days').format(dateFormat);
							}
						}
					});
				};
			},
			template:
				'<div class="searchImageTextBoxContainer">' +
				'<div class="input-group">' +
				'<input placeholder="mm/dd/yyyy" type="text" ng-required="isRequired" ng-model="ngModel" autocomplete="off" ng-disabled="isDisabled" ng-blur="blurfun();" name="{{inputName}}" maxlength=10 uib-datepicker-popup="MM/dd/yyyy" date-disabled="disabled(date, mode)" datepicker-options="dateOptions"' +
				'is-open="openFlag" class="form-control" ng-change="changefun(ngModel);" />' +
				'<span class="input-group-btn" tabindex="-1">' +
				'<button type="button" class="btn btn-default" ng-click="clickfun();" tabindex="0" ng-disabled="isDisabled" title="Open Calendar">' +
				'<i class="fa fa-calendar"></i>' +
				'</button>' +
				'</span>' +
				'</div>' +
				'</div>',
		};
	},
]);
